import { decodeAuthToken } from 'util/decodeAuthToken';
import { isAuthTokenRefreshable } from 'util/isAuthTokenRefreshable';
import { AUTH_STORE_STORAGE_KEY } from 'consts';
import { makeAutoObservable } from 'mobx';
import { makePersistable, isHydrated } from 'mobx-persist-store';

interface AuthStoreInterface {
    authToken: string | null;
}

const initialAuthStore = {
    authToken: null,
};

class AuthStore implements AuthStoreInterface {
    public authToken: AuthStoreInterface['authToken'] = initialAuthStore.authToken;

    public constructor() {
        makeAutoObservable(this);
        makePersistable(this, {
            name: AUTH_STORE_STORAGE_KEY,
            properties: ['authToken'],
            storage: window.localStorage,
        }).then(() => {
            /**
             * на старте приложения, сразу после rehydrate, валидируем токен,
             * если токен уже протух И его невозможно обновить - избавляемся от него
             */
            if (this.authToken) {
                const isTokenRefreshable = isAuthTokenRefreshable(decodeAuthToken(this.authToken));
                this.setAuthToken(isTokenRefreshable ? this.authToken : null);
            }
        });
    }

    public setAuthToken = (token: string | null) => {
        this.authToken = token;
    };

    public get isHydrated() {
        return isHydrated(this);
    }
}

export const authStore = new AuthStore();
